"use client";

import dynamic from "next/dynamic";

const News = dynamic(() => import("@/app/Components/Pages/News"), {
    ssr: false
});

export default function NewsWrapper() {
  return <News />;
}
